module.exports = __webpack_public_path__ + "img/tmp_notice_image_02@3x.36a58c9e.jpg";